
import HeroSection from '../components/landing/HeroSection';
import TrustBadges from '../components/landing/TrustBadges';
import ServiceDifferentiators from '../components/landing/ServiceDifferentiators';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import VehicleSection from '../components/landing/VehicleSection';
import TestimonialsSection from '../components/landing/TestimonialsSection';
import StatsSection from '../components/landing/StatsSection';
import FeaturedServicesSection from '../components/landing/FeaturedServicesSection';
import FeaturedBlogSection from '../components/landing/FeaturedBlogSection';
import ContactSection from '../components/landing/ContactSection';

const LandingPage = () => {
  return (
    <main className="bg-white">
      <HeroSection />
      <TrustBadges />
      <ServiceDifferentiators />
      <HowItWorksSection />
      <FeaturedServicesSection />
      <VehicleSection />
      <StatsSection />
      <TestimonialsSection />
      <FeaturedBlogSection />
      <ContactSection />
    </main>
  );
};

export default LandingPage;
